import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { isNumber, isEmpty, isObject, isNull } from 'lodash';
import { datePickerFormat } from '../../../services/ValidationRules';
import { DateRangePicker } from '../../DateRangePicker/DateRangePicker';
import { DatePicker } from '../../DateTimePickers/DateTimePickers';
import { isDateRangeOperator, isEmptyOperator } from './utils';

const getTodayRange = () => ({
  from: moment.utc().startOf('day').valueOf(),
  to: moment.utc().endOf('day').valueOf(),
});

export class ValueEditorDate extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (props.operator !== state.operator || (!isNumber(props.value) && !isObject(props.value) && !isNull(props.value))) {
      if (isDateRangeOperator(props.operator)) {
        props.onChange(getTodayRange());
      } else {
        props.onChange(moment.utc().valueOf());
      }

      return {
        operator: props.operator,
      };
    }

    return null;
  }

  state = {
    operator: this.props.operator,
  };

  onChangeDate = (date, stringDate) => {
    this.props.onChange(date && date.isValid() ? date.valueOf() : null);
  };

  onChangeRange = (range) => {
    this.props.onChange(range);
  };

  render() {
    if (isDateRangeOperator(this.props.operator)) {
      const value = isNumber(this.props.value) || isEmpty(this.props.value) ? getTodayRange() : this.props.value;

      return (
        <DateRangePicker
          containerClass="date-range-picker-advanced-search"
          value={value}
          onChange={this.onChangeRange}
          disabled={this.props.disabled}
        />
      );
    }

    let value = moment.utc();

    if (isNumber(this.props.value)) {
      value = moment.utc(this.props.value);
    } else if (isObject(this.props.value)) {
      value = moment.utc(this.props.value.from);
    }

    return (
      <DatePicker
        className="value-editor-date"
        dialogProps={{
          style: { zIndex: '1300!important' },
        }}
        isMobile
        clearable
        value={isEmptyOperator(this.state.operator) ? moment.utc() : value}
        placeholder={datePickerFormat}
        format={datePickerFormat}
        onChange={this.onChangeDate}
        disabled={this.props.disabled}
      />
    );
  }
}

ValueEditorDate.propTypes = {
  operator: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};
